import React, {Component} from 'react';
import PropTypes from 'prop-types';
import './style/ShortVideo.css'
import {Button, Popover, Select, Tabs, Icon, Input, Pagination} from "antd";
import {Scrollbars} from "react-custom-scrollbars";
import BaseTable from "../../components/baseTable/BaseTable";
import unverified from "../image/unverified.png"
import {HEADER_HEIGHT} from "../../../constants";
import MyIconSvg from "../iconSvg/svg";
const { TabPane } = Tabs;
const { Option } = Select;
const {Search} = Input;
let width=window.innerWidth-280;
class ShortVideo extends Component {
    constructor(props) {
        super(props);
        this.state={

        }
    }

    render() {
        return (
            <div>
                {this.renderHeader()}
                {this.renderTabTable()}
            </div>
        );
    }

    handleChange=(value)=>{
        console.log(`selected ${value}`);
    };

//    头部
    renderHeader=()=> {
        let {defaultValue,shortVideoWidth,jumpAuthenticationPage,accountInformation,authenticationOk,showReleaseVideosModal,verifyWindowText,disable}=this.props;
        console.log(accountInformation);
        return (
            <div style={{display:'flex',minWidth:500,height:140,backgroundColor:'white'
                ,margin:'auto',alignItems:'center',
                justifyContent:'space-between',
                position:'relative',top:'16px',
                borderRadius: "2px"
            }}>
               <div style={{display:'flex',alignItems:'center',paddingLeft:'40px'}}>
                   {/*头像*/}
                   <div style={{width: 88, height: 88, borderRadius: '50%',}}>
                           <img style={{width: 88, height: 88, borderRadius: '50%'}}
                                src={accountInformation&&accountInformation.head?accountInformation.head:unverified}/>
                   </div>
                   {/*用户名,用户作品数,粉丝数,浏览量*/}

                   <div style={{height:56,paddingLeft:'29px'}}>

                       <div style={{display:'flex'}}>
                           <div style={{fontFamily:"Microsoft YaHei",fontSize:'20px',color:'rgba(0,0,0,0.85)', fontWeight:550}}>{accountInformation&&accountInformation.name?accountInformation.name:"未认证"}</div>
                           <div style={{fontFamily:'Microsoft YaHei', fontWeight: 400, fontSize:'14px',color:'rgba(0,0,0,0.85)',paddingLeft:24,paddingTop:5,cursor:'pointer'}}>
                               {accountInformation&&accountInformation.name?<div style={{marginTop:3}}><MyIconSvg type={'certificationIcon'} style={{size: 15}}/></div>:<div onClick={()=>{jumpAuthenticationPage()}}>去认证<Icon type="double-right" /></div>}
                           </div>
                       </div>
                      { verifyWindowText&&verifyWindowText==="抖音"?null:
                       <div style={{display:'flex',justifyContent:'center',alignItems: 'center',fontSize:'14px',color:'black',paddingTop:17, fontFamily: "Microsoft YaHei",}}>
                           <div style={{display:'flex',justifyContent:'center',alignItems: 'center',}}>
                               <div style={{
                                   fontWeight: 400,
                                   fontSize:'14px',
                                   color: "rgba(0,0,0,0.65)",
                                   lineHeight:'14px'
                               }}>作品：</div>
                               <div style={{
                                   fontWeight: 500,
                                   fontSize:'16px',
                                   color: "rgba(0,0,0,0.85)",
                                   lineHeight:'16px'
                               }}>{this.props.all_count ? this.props.all_count : 0}</div>
                           </div>

                           <div style={{paddingLeft: '24px',display:'flex',justifyContent:'center',alignItems: 'center'}}>
                               <div  style={{
                                   fontWeight: 400,
                                   fontSize:'14px',
                                   color: "rgba(0,0,0,0.65)",
                                   lineHeight:'14px'
                               }}>粉丝：</div>
                               <div
                                   style={{
                                       fontWeight: 500,
                                       fontSize:'16px',
                                       color: "rgba(0,0,0,0.85)",
                                       lineHeight:'16px'
                                   }}>{accountInformation && accountInformation.fan ? accountInformation.fan : 0}</div>
                           </div>

                           <div style={{paddingLeft: '24px',display:'flex',justifyContent:'center',alignItems: 'center'}}>
                               <div style={{
                                   fontWeight: 400,
                                   fontSize:'14px',
                                   color: "rgba(0,0,0,0.65)",
                                   lineHeight:'14px'
                               }}>关注：</div>
                               <div
                                   style={{
                                       fontWeight: 500,
                                       fontSize:'16px',
                                       color: "rgba(0,0,0,0.85)",
                                       lineHeight:'16px'
                                   }}>{accountInformation && accountInformation.follow ? accountInformation.follow : 0}</div>
                           </div>
                       </div>}
                   </div>
               </div>
                {/*选择器*/}
                <Button type={"primary"} style={{marginRight:'32px'}} onClick={showReleaseVideosModal} disabled={(accountInformation&&accountInformation.name) && disable !== 1 ? false:true}>发布视频</Button>
                {/*<div className={'picText'} style={{paddingRight:'32px'}}>*/}
                {/*    <Select defaultValue={defaultValue}*/}
                {/*            showArrow={false}*/}
                {/*            onChange={this.handleChange}*/}
                {/*            style={{width: 105, height: 32}}*/}
                {/*            dropdownStyle={{textAlign:"center"}}*/}
                {/*    >*/}
                {/*        <Option value="创建图文">创建图文</Option>*/}
                {/*        <Option value="选择图文">选择图文</Option>*/}
                {/*    </Select>*/}
                {/*</div>*/}
            </div>
        );
    }
//    tan栏和表格
    renderTabTable=()=>{
        let {tabDate,tabChange,columns,dataSource,tableHeight,tableWidth,onChange,tableDivHeight,keywords}=this.props;

        return(
            <div style={{backgroundColor:'white',margin:'auto',
                position:'relative',top:'28px',
                borderRadius: "2px",
                minWidth:500,
                height:tableDivHeight,
            }}>
                <Search
                    placeholder={"请输入关键字"}
                    allowClear={true}
                    value={keywords}
                    onChange={(e)=>{onChange('onChange',e)}}
                    onSearch={(e)=>{onChange('onSearch',e)}}
                    style={{width: 224,height:32,marginLeft:33,marginTop:24}}
                />
                    {/*tab栏*/}
                    <div className={'navigationBarStyle'}>

                        {
                            (tabDate && tabDate.length)
                                ?
                                (<Tabs defaultActiveKey="1" onChange={tabChange}>
                                    {
                                        tabDate.map((item, index) => {
                                            return (
                                                <TabPane tab={item.key} key={item.key}>
                                                </TabPane>
                                            )
                                        })
                                    }

                                </Tabs>)
                                : null
                        }
                    </div>
                    {/*表格*/}
                    <div style={{paddingTop:'23.5px',margin:"0 33px"}}>
                        <Scrollbars autoHeight autoHeightMax={tableHeight} autoHide height={tableHeight} >
                            <BaseTable columns={columns} dataSource={dataSource} />
                            {/*{dataSource.length<4&&this.renderPage(dataSource)}*/}
                        </Scrollbars>
                        { dataSource.length>0&&this.renderPage(dataSource)}
                    </div>
                {/*<div style={{position:'absolute',display: "flex",justifyContent:'flex-end'}}>*/}

                {/*</div>*/}
            </div>
        )
    }
    // 分页栏
    renderPage=(dataSource)=>{
        let {onChange,tableWidth,total,params}=this.props;
        return(
            <div style={dataSource.length>=4?{
                position: 'absolute',
                right: 11,
                bottom: 0,
                height:'50px',
                display: "flex",
                marginTop:'10px',
                justifyContent:'flex-end',
                alignItems:'center'
            }:{
                height:'50px',
                display: "flex",
                marginTop:'10px',
                justifyContent:'flex-end',
                alignItems:'center'
            }}
                 className={'PageStyle'}
            >
                <Pagination
                    style={{paddingRight:'20px'}}
                    size="middle"
                    total={total}
                    showTotal={(total) => `共有${total}条数据`}
                    showSizeChanger
                    showQuickJumper
                    current={params.page}
                    pageSize={params.size}
                    onChange={(page,pageSize)=>{onChange('page',"",page,pageSize)}} //页码改变时回调
                    onShowSizeChange={(page,pageSize)=>{onChange('size',"",page,pageSize)}} //每页条数改变回调
                />
            </div>
        )
    }
}

ShortVideo.propTypes = {
    /**
     * @text tab栏数据
     * @category array
     */
    tabDate:PropTypes.array,
    /**
     * @text 表格数据
     * @category array
     */
    dataSource:PropTypes.array,
    /**
     * @text 表格头数据
     * @category array
     */
    columns:PropTypes.array,
    /**
     * @text tab栏切换方法
     * @category array
     */
    tabChange:PropTypes.func,
};

ShortVideo.defaultProps={
    defaultValue:'发布图文...',
}

export default ShortVideo;